import Ruler from '../../src/legacy/Ruler';
export default Ruler;
